//import { render } from "@testing-library/react";
import React,{useState} from "react";
import {Modal,Button} from 'react-bootstrap';
//import Back from "./Back";
import { withRouter } from "react-router-dom";
import config from "../config";
//const axios = require("axios");
//const history = useHistory();

const ModalError = ({history})=> {
  const [isOpen, setisOpen]=useState(true);
  const closeModal=(e)=>{setisOpen(false); history.goBack();}
  return(
history.length > 1 && (

  <React.Fragment>
  <Modal show={isOpen} onHide={closeModal}  aria-labelledby="contained-modal-title-vcenter" class="modal-top-right">
    <Modal.Header closeButton style={{backgroundColor:"black", color:"white", height:"40px", paddingTop:2}}>
      <Modal.Title style={{ paddingTop:0}}>{config.gvr.ErrMsgs.TitleUnknown}</Modal.Title>
    </Modal.Header> 
    <Modal.Body style={{ height:"75px"}}>{config.gvr.ErrMsgs.MsgUnknown}</Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={closeModal}  style={{backgroundColor:"gray", borderColor: "black"}}>
        Login 
      </Button>
    </Modal.Footer>
  </Modal>
</React.Fragment>));
  }



export default withRouter(ModalError);
  